

import { Button, Card, Col, Collapse, Drawer, Grid, Input, Modal, Row, Switch, Table, Tag, Tooltip, Typography } from 'antd';
import AccountData from '../../../models/AccountData';
import './AccounstListComponent.scss'
import { GetAccountsIcon, getAccountTypeIcon } from '../../../utils/icons';
import moment from 'moment';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { SmallCompanyData } from '../../../models/SmallCompanyData';
import { SmallAgencyData } from '../../../models/SmallAgencyData';
import AccountUsersPage from '../../../pages/Private/AccountUsersPage/AccountUsersPage';
import { useNavigate } from 'react-router-dom';
import { GetFormattedUrl } from '../../../utils/urls';
import { LoadingData } from '../../common';
import { AreaChartOutlined, EditOutlined, GlobalOutlined, HomeOutlined, IdcardOutlined, MailOutlined, SignatureOutlined, StarFilled, TeamOutlined } from '@ant-design/icons';
import HTMLReactParser from 'html-react-parser';
import './AccounstListComponent.scss'
import { Contract } from '../../../models/Contract';
import ValidateAccountForm from '../form/ValidateAccountForm';
import { GenericModal } from '../../common/Modal/GenericModal';
import { GetConfigurationAvailableForAccount, GetPaymentConfigurationAvailableForAccount, GetPaymentsMethodConfiguration, GetPaymentsMethods, GetPossibleConfigurationAvailableForAccount } from '../../../api/repositoryEP';
import { PaymentConfigurationData } from '../../../models/PaymentMethodData';
import ApiResponse from '../../../models/api/ApiResponse';
import { ConfigurationAvailableForAccount, PossibleConfigurationAvailableForAccount } from '../../../models/AccountAsignationData';
import { set } from 'lodash';

interface AccountsListComponentProps {
    list: AccountData[];
    loading: boolean;
    companies: SmallCompanyData[];
    agencies: SmallAgencyData[];
    contracts: Contract[]
    onEditAccount: (id: string, isActive: boolean, typeAccount: string, contractConfigurationId: string[], paymentConfigurationId: string, useSpecificConfiguration: boolean | null, verificationCode?: string) => Promise<ApiResponse | null>;
    onDeleteAccount: (id: string, typeAccount: string) => Promise<ApiResponse | null>;
    onUpdateVerificationCode: (id: string, typeAccount: string, currentStatus: string, verificationCode: string) => Promise<ApiResponse | null>;

}

const AccountsListComponent = (props: AccountsListComponentProps): JSX.Element => {
    const appConfig = useAppConfig();
    const { t } = useTranslation();
    const { list, loading, companies, agencies } = props;
    const navigate = useNavigate();
    const [drawerVisible, setDrawerVisible] = useState<boolean>(false); // drawer of accounts
    const [selected, setSelected] = useState<AccountData>();
    const [validateAccountModalVisible, setValidateAccountModalVisible] = useState<boolean>(false);
    const [changingStatus, setChangingStatus] = useState<boolean>(false);
    const [isVisibleModalActivationAccount, setIsVisibleModalActivationAccount] = useState<boolean>(false);
    const [paymentsConfiguration, setPaymentsConfiguration] = useState<ConfigurationAvailableForAccount[]>([]);
    const [commissionConfiguration, setCommissionConfiguration] = useState<PossibleConfigurationAvailableForAccount[]>([]);
    const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
    const [deletingAccount, setDeletingAccount] = useState<boolean>(false);
    const [editVerifCodeVisible, setEditVerifCodeVisible] = useState<boolean>(false);
    const [editVerifCodeLoading, setEditVerifCodeLoading] = useState<boolean>(false);
    const [editVerifCodeValue, setEditVerifCodeValue] = useState<string>('');

    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const modalWidth = screens.xs
        ? '95%'
        : screens.sm
            ? '40%'
            : screens.md
                ? '20%'
                : '20%';



    const goBookings = (account: AccountData) => {
        navigate(GetFormattedUrl(`private/bookings-admin?type=${account.type}&account=${account.id}`))
    }



    const showEditDrawer = (item: AccountData) => {
        setSelected(item);
        setDrawerVisible(true);
    }
    const showValidateAccountDrawer = (item: AccountData) => {
        setSelected(item);
        setValidateAccountModalVisible(true);
    }

    useEffect(() => {
        console.log("Updated", companies, agencies)
    }, [agencies, props.agencies, companies, props.companies])

    const [loadingCommissionConfiguration, setLoadingCommissionConfiguration] = useState<boolean>(false);
    const [loadingPaymentConfiguration, setLoadingPaymentConfiguration] = useState<boolean>(false);
    const [hotelSearch, setHotelSearch] = useState<Record<string, string>>({});





    const onEditAccount = async (id: string, isActive: boolean, type: string, contractConfigurationId: string[], paymentConfigurationId: string, useSpecificConfiguration?: boolean | null, verificationCode?: string): Promise<ApiResponse | null> => {
        return await props.onEditAccount(id, isActive, type, contractConfigurationId, paymentConfigurationId, useSpecificConfiguration ?? null, verificationCode);
    }


    const loadCommisionConfiguration = async (accountData: AccountData | undefined) => {
        try {
            if (!accountData?.id || !accountData?.type) {
                setCommissionConfiguration([]);
                return;
            }
            setLoadingCommissionConfiguration(true);

            const response = await GetPossibleConfigurationAvailableForAccount(accountData.id, accountData.type);

            setCommissionConfiguration(response?.data ?? []);
            setLoadingCommissionConfiguration(false);

        } catch (error) {
            console.error('Error loading payment configurations', error);
            setCommissionConfiguration([]);
        }
    };
        const loadPaymentConfiguration = async (accountData: AccountData | undefined) => {
        try {
            if (!accountData?.id || !accountData?.type) {
                setPaymentsConfiguration([]);
                return;
            }
            setLoadingPaymentConfiguration(true);

            const response = await GetPaymentConfigurationAvailableForAccount(accountData.id, accountData.type);

            setPaymentsConfiguration(response?.data ?? []);
            setLoadingPaymentConfiguration(false);

        } catch (error) {
            console.error('Error loading payment configurations', error);
            setPaymentsConfiguration([]);
        }
    };

    useEffect(() => {
        if (isVisibleModalActivationAccount && selected) {
            loadCommisionConfiguration(selected);
            loadPaymentConfiguration(selected);
        }
    }, [isVisibleModalActivationAccount, selected]);


    useEffect(() => {
        console.log("cambiamos ", changingStatus)
    }, [changingStatus])

    const toTitleCase = (str: string) =>
        str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());

    return (
        <div className="accounts-list">
            <Drawer open={drawerVisible}
                title={<span>{selected?.commercialName}<small style={{ display: "block" }}>{selected?.address}</small></span>}
                onClose={() => { setDrawerVisible(false) }}
                width={"50%"}
                closable
                destroyOnClose>
                <AccountUsersPage accountData={selected} />
            </Drawer>
            <GenericModal
                title={t('components.accounts.list.edit-verification-code-title')}
                closable
                content={
                    <div>
                        <label style={{ display: 'block', marginBottom: 8 }}>{t('components.accounts.list.validate-account-verification-code-label')}</label>
                        <Input
                            className="app-input"
                            value={editVerifCodeValue}
                            onChange={e => setEditVerifCodeValue(e.target.value)}
                        />
                    </div>
                }
                visible={editVerifCodeVisible}
                isLoading={editVerifCodeLoading}
                onOk={async () => {
                    if (selected) {
                        setEditVerifCodeLoading(true);
                        try { await props.onUpdateVerificationCode(selected.id, selected.type, selected.status, editVerifCodeValue); }
                        finally { setEditVerifCodeLoading(false); setEditVerifCodeVisible(false); }
                    }
                }}
                onCancel={() => setEditVerifCodeVisible(false)}
            />

            <GenericModal
                title={t('components.accounts.list.delete-account-confirm-title')}
                closable
                content={<div>{HTMLReactParser(t('components.accounts.list.delete-account-confirm-message', { 0: selected?.commercialName }))}</div>}
                visible={deleteModalVisible}
                isLoading={deletingAccount}
                okDanger
                onOk={async () => {
                    if (selected) {
                        setDeletingAccount(true);
                        try { await props.onDeleteAccount(selected.id, selected.type); }
                        finally { setDeletingAccount(false); setDeleteModalVisible(false); }
                    }
                }}
                onCancel={() => setDeleteModalVisible(false)}
            />

            <Modal
                open={isVisibleModalActivationAccount}
                title={t('components.accounts.list.validate-account-title')}
                onCancel={() => { setIsVisibleModalActivationAccount(false) }}
                footer={null}
                width={modalWidth}
                closable
            >
                <ValidateAccountForm
                    drawerVisible={isVisibleModalActivationAccount}
                    setDrawerVisible={setIsVisibleModalActivationAccount}
                    commissionConfiguration={commissionConfiguration}
                    paymentsConfiguration={paymentsConfiguration}
                    accountData={selected}
                    onValidateAccount={onEditAccount}
                    loadingCommissionConfiguration={loadingCommissionConfiguration}
                    loadingPaymentConfiguration={loadingPaymentConfiguration}
                />
            </Modal>

            {
                loading && <LoadingData />
            }
            {
                !loading && list.map((item: AccountData, index: number) => {


                    const statusColor: Record<string, string> = {
                        active: '#52c41a', inactive: '#d9d9d9',
                        validation_needed: '#faad14', pending: '#1677ff', error: '#ff4d4f'
                    };
                    const accentColor = statusColor[item.status] ?? '#d9d9d9';

                    const statusTagColor: Record<string, string> = {
                        inactive: 'default',
                        validation_needed: 'warning',
                        pending: 'processing',
                        error: 'error'
                    };

                    return (
                        <div className="acc-card" key={index}>

                            {/* ── Franja lateral de color por estado ── */}
                            <div className="acc-card__accent" style={{ background: accentColor }} />

                            {/* ── Contenido principal ── */}
                            <div className="acc-card__body">

                                {/* Header */}
                                <div className="acc-card__header">
                                    <div className="acc-card__title-row">
                                        <Tooltip title={t(`components.accounts.list.account-type-${item.type}`)}>
                                            <span className="acc-card__type-icon">{getAccountTypeIcon(item.type)}</span>
                                        </Tooltip>
                                        <div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                <span className="acc-card__name">{toTitleCase(item.commercialName ?? '')}</span>
                                                {item.status !== 'active' && (
                                                    <Tag color={statusTagColor[item.status] ?? 'default'}>
                                                        {t(`components.accounts.list.status-label-${item.status}`)}
                                                    </Tag>
                                                )}
                                            </div>
                                            {item.creationDate && (
                                                <span className="acc-card__creation">
                                                    {t('components.accounts.list.creation-date')}: {moment(item.creationDate).format(appConfig.config.dateFormat)}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="acc-card__actions">
                                        {(item.verificationCode || item.type === 'agency_agent' || item.type === 'corporate_agent') && (
                                            <Tooltip title={t('components.accounts.list.edit-verification-code-title')}>
                                                <Tag
                                                    color="blue"
                                                    className="acc-card__verif-tag"
                                                    style={{ cursor: 'pointer' }}
                                                    icon={<EditOutlined />}
                                                    onClick={() => { setSelected(item); setEditVerifCodeValue(item.verificationCode ?? ''); setEditVerifCodeVisible(true); }}
                                                >
                                                    {item.verificationCode || t('components.accounts.list.edit-verification-code-title')}
                                                </Tag>
                                            </Tooltip>
                                        )}
                                        {item.status === 'validation_needed' ? (
                                            <>
                                            <Button size="small" className="app-button" onClick={() => { setSelected(item); setIsVisibleModalActivationAccount(true); }}>
                                                {t('components.accounts.list.validate-account-activate-account-button')}
                                            </Button>
                                            <Button size="small" className="app-button danger" onClick={() => { setSelected(item); setDeleteModalVisible(true); }}>
                                                {t('components.accounts.list.delete-account-button')}
                                            </Button>
                                            </>
                                        ) : (item.status === 'active' || item.status === 'inactive') ? (
                                            <Switch
                                                className="app-switch"
                                                value={item.status === 'active'}
                                                defaultChecked={item.status === 'active'}
                                                disabled={changingStatus && item.id === selected?.id}
                                                onChange={async (checked) => {
                                                    setSelected(item); setChangingStatus(true);
                                                    try { await onEditAccount(item.id, checked, item.type, [], '', null); }
                                                    finally { setChangingStatus(false); }
                                                }}
                                            />
                                        ) : (
                                            <Button size="small" className="app-button" onClick={() => showValidateAccountDrawer(item)}>
                                                {t('components.accounts.list.validate-account-button')}
                                            </Button>
                                        )}
                                    </div>
                                </div>

                                {/* Info grid */}
                                <div className="acc-card__info">
                                    {/* Gestor / dirección */}
                                    <div className="acc-card__info-block">
                                        <span className="acc-card__info-label">
                                            <span className="acc-icon-wrap">{GetAccountsIcon('acc-svg-icon')}</span>
                                            {t('components.accounts.manage.creation-date') ? 'Gestor' : 'Gestor'}
                                        </span>
                                        {item.manager && <span className="acc-card__info-value">{item.manager}</span>}
                                        {item.address && <span className="acc-card__info-value acc-card__info-value--muted">{item.address}</span>}
                                        {item.isoCountryCode && (
                                            <span className="acc-card__market-tag">
                                                <GlobalOutlined />
                                                {item.isoCountryCode.toUpperCase()}
                                            </span>
                                        )}
                                        {!item.manager && !item.address && !item.isoCountryCode && <span className="acc-card__info-value acc-card__info-value--muted">-</span>}
                                    </div>

                                    {/* ID Fiscal */}
                                    {item.fiscalId && (
                                        <div className="acc-card__info-block">
                                            <span className="acc-card__info-label"><IdcardOutlined className="acc-icon" />{t('components.accounts.list.fiscal-id')}</span>
                                            <span className="acc-card__info-value">{item.fiscalId}</span>
                                        </div>
                                    )}

                                    {/* Contacto */}
                                    <div className="acc-card__info-block">
                                        <span className="acc-card__info-label"><MailOutlined className="acc-icon" />{t('components.accounts.list.email').replace(': ', '') || 'Contacto'}</span>
                                        {item.contact?.email
                                            ? <a href={`mailto:${item.contact.email}`} className="acc-card__info-value acc-card__link">{item.contact.email}</a>
                                            : <span className="acc-card__info-value acc-card__info-value--muted">-</span>}
                                        {item.contact?.phone && <span className="acc-card__info-value acc-card__info-value--muted">{item.contact.phone}</span>}
                                    </div>

                                    {/* Métricas */}
                                    <div className="acc-card__info-block">
                                        <span className="acc-card__info-label"><AreaChartOutlined className="acc-icon" />{t('components.accounts.list.statistics.requests')} / L2B</span>
                                        <div className="acc-card__chips">
                                            <span className="acc-chip">
                                                <strong>{item.totalAccountRequests ?? 0}</strong> {t('components.accounts.list.statistics.requests')}
                                            </span>
                                            <span className="acc-chip acc-chip--l2b">
                                                <strong>{item.conversionRatio ?? 0}%</strong> L2B
                                            </span>
                                        </div>
                                    </div>

                                    {/* Usuarios + Reservas */}
                                    <div className="acc-card__info-block acc-card__info-block--last">
                                        <span className="acc-card__info-label"><TeamOutlined className="acc-icon" />{t('components.accounts.list.number-of-users')} / {t('components.accounts.list.number-of-bookings')}</span>
                                        <div className="acc-card__chips">
                                            <span
                                                className={`acc-chip${(item.resume?.usersNumber ?? 0) > 0 ? ' acc-chip--clickable' : ''}`}
                                                onClick={(item.resume?.usersNumber ?? 0) > 0 ? () => showEditDrawer(item) : undefined}
                                            >
                                                <TeamOutlined /> <strong>{item.resume?.usersNumber ?? 0}</strong> {t('components.accounts.list.number-of-users')}
                                            </span>
                                            <span
                                                className={`acc-chip${(item.resume?.bookingNumber ?? 0) > 0 ? ' acc-chip--clickable acc-chip--booking' : ''}`}
                                                onClick={(item.resume?.bookingNumber ?? 0) > 0 ? () => goBookings(item) : undefined}
                                            >
                                                <strong>{item.resume?.bookingNumber ?? 0}</strong> {t('components.accounts.list.number-of-bookings')}
                                            </span>
                                            {(item.activeBookingCounter ?? 0) > 0 && (
                                                <span className="acc-chip acc-chip--active">
                                                    <strong>{item.activeBookingCounter}</strong> {t('components.accounts.list.statistics.active-bookings')}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Contratos */}
                                {item.contracts.length > 0 && (
                                    <div className="acc-card__contracts">
                                        <span className="acc-card__info-label acc-card__info-label--contracts">
                                            <SignatureOutlined className="acc-icon" />{t('components.accounts.list.contract.title')}
                                        </span>
                                        <Collapse accordion className="acc-collapse">
                                            {item.contracts.map((contract, cIndex) => {
                                                const searchKey = `${item.id}_${contract.id}`;
                                                const searchVal = hotelSearch[searchKey] || '';
                                                const filteredHotels = contract.hotelsAffected.filter(h =>
                                                    h.name.toLowerCase().includes(searchVal.toLowerCase())
                                                );
                                                return (
                                                    <Collapse.Panel
                                                        key={cIndex}
                                                        header={
                                                            <span className="acc-contract-header">
                                                                <span className="acc-contract-name"
                                                                    onClick={e => { e.stopPropagation(); navigate(GetFormattedUrl(`private/contracts?name=${encodeURIComponent(contract.name)}`)); }}
                                                                >{contract.name}</span>
                                                                {contract.isBase && (
                                                                    <Tooltip title={t('components.accounts.base-contract')}>
                                                                        <StarFilled style={{ color: '#faad14' }} />
                                                                    </Tooltip>
                                                                )}
                                                            </span>
                                                        }
                                                    >
                                                        {contract.hotelsAffected.length > 0 ? (
                                                            <>
                                                                <Input.Search size="small"
                                                                    placeholder={t('components.accounts.list.search-hotel') || 'Buscar hotel...'}
                                                                    value={searchVal}
                                                                    onChange={e => setHotelSearch(prev => ({ ...prev, [searchKey]: e.target.value }))}
                                                                    onSearch={val => setHotelSearch(prev => ({ ...prev, [searchKey]: val }))}
                                                                    style={{ marginBottom: 8 }} allowClear
                                                                />
                                                                <Table className="hotels-table" dataSource={filteredHotels} rowKey="id"
                                                                    size="small" showHeader={false}
                                                                    pagination={{ pageSize: 5, hideOnSinglePage: true, size: 'small' }}
                                                                    columns={[{ dataIndex: 'name', render: (name: string) => (
                                                                        <span className="hotel-table-row"><HomeOutlined className="hotel-icon" />{name}</span>
                                                                    )}]}
                                                                />
                                                            </>
                                                        ) : (
                                                            <Typography.Text type="secondary">{t('alert.no-hotels-associated')}</Typography.Text>
                                                        )}
                                                    </Collapse.Panel>
                                                );
                                            })}
                                        </Collapse>
                                    </div>
                                )}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default AccountsListComponent;